import { useEffect } from 'react';
import ReactGA from 'react-ga';
import normalizeArrayOfString from '../utils/normalizeArrayOfString';

/**
 * @param {object} options
 * @param {string} [options.path] - The path portion of a URL
 * @param {string|string[]} [options.trackerNames] - Google analytics tracker Name
 * @param {string} [options.title=document.title] - Page title
 * @see {@link https://github.com/react-ga/react-ga#reactgapageviewpath}
 * @see {@link https://developers.google.com/analytics/devguides/collection/analyticsjs/pages}
 */
export default function usePageview(options) {
  useEffect(() => {
    ReactGA.pageview(
      options.path || `${location.pathname}${location.search}`,
      normalizeArrayOfString(options.trackerNames),
      options.title
    );
  }, []);
}
